import { IResponseSummaryResponse } from "./IResponseSummaryResponse";

export interface ISurveyQuestion {
  id: number;
  surveyId: number;
  type: number;
  category: number;
  coachText: string;
  studentText: string;
  parentText: string;
  order: number;
}

export interface ISurvey {
  count: any;
  id: number;
  name: string;
  studentCode: string;
  coachCode: string;
  coachId?: number;
  parentCode: string;
  enableParentQuestions: boolean;
  completedSurveyCoachIds: number[];
  coachIds: number[];
  startDate: number;
  responseCollectionEndDate: number | null;
  hasWrittenQuestions: boolean;
  sportId: number;
  schoolId: number;
  defaultScale: number;
  defaultReversed: boolean;
  defaultPositiveText: string;
  defaultNegativeText: string;
  questions: ISurveyQuestion[];
  questionSummaries: IResponseSummaryResponse[];
  type: number;
  complete: boolean;
  entryLevel?: number;
}

export enum ResponseSource {
  coach,
  student,
  parent,
}



// WEBPACK FOOTER //
// ./src/api/types/ISurvey.ts